export default __webpack_public_path__ + "static/media/visa.272db12e.svg";